export default "__VITE_ASSET__DyjZX7Zw__"